'use es6';
/**
 * @type {String} Id and sessionId of the eslintrc code editor in settings.
 */

export const SETTINGS_ESLINTRC_ID = 'settings-js-linter-eslint';
/**
 * @type {String} Id and sessionId of the eslint demo code editor in settings.
 */

export const SETTINGS_ESLINT_DEMO_ID = 'settings-js-linter-demo';
/**
 * @type {Boolean}
 */

export const DEFAULT_IS_ENABLED = false;
/**
 * @type {String} JSON
 */

export const DEFAULT_CONFIG = `{
  "extends": "eslint:recommended",
  "parserOptions": {
    "ecmaVersion": 5
  },
  "env": {
    "browser": true,
    "jquery": true,
    "es6": false
  },
  "rules": {
    "semi": "error",
    "no-console": "warn",
    "no-unused-vars": "warn"
  },
  "globals": {
    "hsInEditor": "readonly",
    "hs_i18n_getMessage": "readonly",
    "hs_i18n_insertPlaceholders": "readonly",
    "hs_i18n_log": "readonly",
    "hs_i18n_substituteStrings": "readonly",
    "hbspt": "readonly"
  }
}`;
export const DEMO_CODE = `
var unused = 88;
var semicolons = 'missing'

function unreachable() {
  var a = 2 + 4;
  return a;
  var b = 8 + 16;
  return b;
}

for (var index = 10; index--;) {
  console.log(index);
  undefinedVariable += index;
}

// https://developers.hubspot.com/manipulating-forms-with-jquery
$(function() {
  hbspt.forms.create({
    portalId: 'XXXXXX',
    formId: 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXX',
    onFormReady: function($form, ctx) {
      $('input[value="checkbox_1"]').prop('checked', true).change();
    }
  });
});

// eslint-disable-next-line no-unused-vars, no-compare-neg-zero
var test = 99 === -0;

/* eslint-disable */
try {
  unreachable();
} catch (error) { }
/* eslint-enable */

//const ecmaVersion6 = \`hello\$\{unreachable()\}\`;
//const envEs6 = new Map();
//const ecmaVersion7 = (2 ** 31) - 1;
`.replace(/^\s+/, '');